<div id="global-filter-section" class="global-filter-section" [class.hideGlobalFilter]="isHierarchFilterHidden">
  <div class="container-fluid padding-0">
    <div class="global-filter-container">
      <div class="left-panel">
        <div class="row">
          <div class="drawer-left-panel">
            <!-- <div class="hierarchy-filter-panel">
              
              <span class="text-nowrap  line-height">{{
                "HIERARCHY" | translate
              }}</span>
              <span
                class="input-group-text default-access"
                [class.active]="isHierarchFilterActive"
                id="addon-wrapping"
                (click)="openGlobalFilterSideBar($event, 'hierarchy')"
              >
                <img
                  src="assets/images/hierarchy.svg"
                  id="set-hierarchy-icon"
                />

                <span class="circle-loader" *ngIf="isHierarchyInitializing"></span>
                <span
                  *ngIf="! isHierarchyInitializing && 
                    !isHierarchyFilterInitialised &&
                    mappedHierarchyLevelNames &&
                    loggedInUserLevel
                  "
                >
                  <span>{{  mappedHierarchyLevelNames[loggedInUserLevel]  }}</span>
                  <span
                    *ngIf="loggedInUserValues.length == 1"
                    class="text-dark"
                    id="hierarchy-value"
                    role="button"
                    (click)="openGlobalFilterSideBar($event, 'hierarchy')" >{{ loggedInUserValues[0] }}</span >
                  <span
                    *ngIf="loggedInUserValues.length > 1"
                    class="text-dark"
                    id="hierarchy-value"
                  >
                    <select
                      name=""
                      id="defaultAccess"
                      role="button"
                      [(ngModel)]="selectedHierarchyValue"
                      (click)="$event.stopPropagation()"
                      (change)="updateHierarchyFilter($event)"
                    >
                      <option
                        
                        *ngFor="let item of loggedInUserValues; let i = index"
                        [value]="item"
                      >
                        {{ item }}
                      </option>
                    </select>
                  </span>
                </span>
              </span>
            </div> -->
            <!-- <div class="active-filters-panel" *ngIf="(isActiveFiltersEnabled && isHierarchFilterActive) || (isActiveFiltersEnabled && isAddfilterBtnEnabled)">
              <span>Active Filters : </span>
              <div
                class="active-filters"
                *ngIf="isHierarchFilterActive"
                (click)="openGlobalFilterSideBar($event, 'hierarchy')"
              >
                Hierarchy
              </div>
              <div
                class="active-filters"
                *ngIf="activeUniversalFilter.question_filter && isAddfilterBtnEnabled"
                (click)="openGlobalFilterSideBar($event, 'question_filter')"
              >
                Questions
                <img
                  class="filter-close-icon"
                  (click)="clearActiveFilters($event, 'question_filter')"
                  src="assets/images/close.svg"
                />
              </div>
              <div
                class="active-filters"
                *ngIf="activeUniversalFilter.text_filter  && isAddfilterBtnEnabled"
                (click)="openGlobalFilterSideBar($event, 'text_filter')"
              >
                Text
                <img
                  class="filter-close-icon"
                  (click)="clearActiveFilters($event, 'text_filter')"
                  src="assets/images/close.svg"
                />
              </div>
              <div
                class="active-filters"
                *ngIf="activeUniversalFilter.action_filter  && isAddfilterBtnEnabled"
                (click)="openGlobalFilterSideBar($event, 'action_filter')"
              >
                Action
                <img
                  class="filter-close-icon"
                  (click)="clearActiveFilters($event, 'action_filter')"
                  src="assets/images/close.svg"
                />
              </div>
              <div
                class="active-filters"
                *ngIf="activeUniversalFilter.transaction_filter  && isAddfilterBtnEnabled"
                (click)="openGlobalFilterSideBar($event, 'transaction_filter')"
              >
                Metadata
                <img
                  class="filter-close-icon"
                  (click)="clearActiveFilters($event, 'transaction_filter')"
                  src="assets/images/close.svg"
                />
              </div>
            </div> -->
            <app-hierarhy-filter-button></app-hierarhy-filter-button>
            <app-active-filters-chips></app-active-filters-chips>
          </div>
        </div>
      </div>
      <div class="right-panel">
        <div
          class="col input-group flex-nowrap"
          *ngIf="canShowNewHuddleButton()"
        >
          <label
            role="button"
            class="creation-button"
            placeholder="Section 3"
            aria-label="Username"
            aria-describedby="addon-wrapping"
          >
            <span (click)="openHuddleCreationSidebar()">
              Start a new huddle
            </span>
          </label>
        </div>
      
        <app-huddle-creation
          *ngIf="isHuddleCreationSidebarOpen"
          (closeSidebar)="closeHuddleCreationSidebar()"
        ></app-huddle-creation>
      
        <app-add-filters-button [isAddfilterBtnEnabled]="isAddfilterBtnEnabled" [isUniversalFilterEnabled]="isUniversalFilterEnabled" [isHuddleFilterEnabled]="isHuddleFilterEnabled"></app-add-filters-button>
      </div>      
    </div>
    <div class="row" *ngIf="isHierarchFilterActive">
      <div class="global-filter-breadcrum">
        <div *ngIf="appliedFilterTrail"><p [innerHTML]="appliedFilterTrail"></p></div>
      </div>
    </div>
  </div>

</div>
